"use client";

import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";

function BetterSolutions() {
  return (
    <motion.div
      className="better-solutions"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <motion.div
        className="better-solutions__tagline"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        Why we're the best choice
      </motion.div>

      <motion.h1
        className="better-solutions__headline"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        Your Gateway to Global Cross-Border
        <br className="better-solutions__headline-break" /> Payments Seamlessly
      </motion.h1>

      <div className="better-solutions__mockups">
        <motion.div
          className="better-solutions__mockups-phoneimg"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754987059/image_113_zjp7yc.png"
            width={460}
            height={748}
            alt="better-son-phoneImg"
          />

          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752905673/image_114_gmhjjg.png"
            width={278}
            height={170}
            alt="better-son-phoneImg"
            className="better-solutions__mockups-phoneimgBlur"
          />

          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752905673/Frame_1618870195_mu6til.png"
            width={316}
            height={194}
            alt="better-son-phoneImg"
            className="better-solutions__mockups-phoneimgBanner"
          />

          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752912820/image_119_guaef7.png"
            width={412}
            height={106}
            alt="better-son-phoneImg"
            className="better-solutions__mockups-phoneimgAction"
          />
        </motion.div>

        <motion.div
          className="better-solutions__mockups-dashImg"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 1.0 }}
        >
          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752905673/image_111_ybzkit.png"
            width={1001}
            height={748}
            alt="better-son-phoneImg"
          />

          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752905673/image_121_pj62xl.png"
            width={767.5}
            height={231}
            alt="better-son-phoneImg"
            className="better-solutions__mockups-dashimgBanner"
          />

          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752905673/image_122_lktg6c.png"
            width={737.5}
            height={122}
            alt="better-son-phoneImg"
            className="better-solutions__mockups-dashimgAction"
          />

          <Image
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1752905674/image_123_tdk7ny.png"
            width={774}
            height={73}
            alt="better-son-phoneImg"
            className="better-solutions__mockups-dashimgtransaction"
          />
        </motion.div>
      </div>
    </motion.div>
  );
}

export default BetterSolutions;
